// Standard storefront navigation shared by every theme. Themes decide how it looks, never what it contains.

/** Header menu — identical destinations on every theme. */
export const navLinks = (slug) => [
  ["Home", `/store/${slug}`],
  ["Shop", `/store/${slug}/shop`],
  ["About", `/store/${slug}/about`],
  ["Track Order", `/store/${slug}/track`],
  ["Blogs", `/store/${slug}/blogs`],
  ["Contact", `/store/${slug}/contact`],
  ["My Account", `/store/${slug}/account`],
];

/** Policy pages a vendor can write (Setup -> Policy Pages); the key is the storefront route. */
export const POLICY_LINKS = [
  ["privacy-policy", "Privacy Policy"],
  ["terms-and-conditions", "Terms and Conditions"],
  ["return-policy", "Return Policy"],
  ["ip-policy", "IP Policy"],
];

/** Footer link columns (the approved footer structure). Anchors point at the homepage sections. */
export const footerColumns = (slug) => [
  ["Information", POLICY_LINKS.map(([key, label]) => [label, `/store/${slug}/${key}`])],
  ["Account", [["My account", `/store/${slug}/account`], ["Track order", `/store/${slug}/track`], ["Cart", `/store/${slug}/checkout`], ["Reviews", `/store/${slug}#reviews`]]],
  ["Store", [["All products", `/store/${slug}/shop`], ["Categories", `/store/${slug}#categories`], ["Best sellers", `/store/${slug}#bestsellers`]]],
];

/** Free-delivery threshold of a store in ₹ (vendor setting, Store Settings). 0 = no free-delivery offer; unset (older stores) = 999. */
export const freeOver = (store) => { const v = store?.free_shipping_over; return v == null ? 999 : Number(v) || 0; };
export const freeShipNote = (store) => (freeOver(store) > 0 ? `Free delivery on orders over ₹${freeOver(store).toLocaleString("en-IN")}` : null);

/** Trust strip shown above the footer columns. */
export const trustItems = (requiresPrescription, freeShippingOver) => [
  ["money", "100% Money back", "If the order is not as described"],
  ["verified", "Genuine & verified", requiresPrescription ? "Prescriptions checked by a pharmacist" : "Quality-checked products"],
  freeOver({ free_shipping_over: freeShippingOver }) > 0
    ? ["delivery", "Free delivery", `On orders over ₹${freeOver({ free_shipping_over: freeShippingOver }).toLocaleString("en-IN")}`]
    : ["delivery", "Reliable delivery", "Tracked, courier-delivered orders"],
];

/** Footer location / support lines (business name from the store profile; no private owner contact details). */
export const footerLines = (store) => ({
  location: store.business_name,
  support: "Support through order tracking, 24×7",
});

/** Scroll to a hash target after navigation (used for /store/slug#deals style links). */
export function scrollToHash(hash) {
  if (!hash) return;
  const el = document.getElementById(hash.replace("#", ""));
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
}

/** Is this header-menu item the page the shopper is on? Home matches only the home page; Shop also covers product pages. */
export function isNavActive(pathname, slug, to) {
  const base = `/store/${slug}`;
  const path = (pathname || "").replace(/\/+$/, "") || "/";
  if (to === base) return path === base;
  if (to === `${base}/shop`) return path === to || path.startsWith(`${base}/product/`);
  return path === to || path.startsWith(`${to}/`);
}
